import { render, staticRenderFns } from "./stadiums.vue?vue&type=template&id=3226e2c6&"
import script from "./stadiums.vue?vue&type=script&lang=ts&"
export * from "./stadiums.vue?vue&type=script&lang=ts&"
import style0 from "./stadiums.vue?vue&type=style&index=0&id=3226e2c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports